<div class="wrapper">
    <div class="back" (click)="back()">
        <i class="fa fa-arrow-left"></i>
    </div>
    <div class="page-header">
        <h2>{{editMode ? 'Edit Notification' : 'Add Notification'}}</h2>
    </div>
    <form [formGroup]="notificationForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="section-title">Notification Details</div>
        <div class="form-grid">
            <div class="form-group">
                <label for="title">Title <span class="required">*</span></label>
                <input id="title" type="text" (keypress)="wordLimitValidator($event,'title')" (paste)="handlePaste($event)" formControlName="title" placeholder="Enter Title" />
                <span class="text-danger" *ngIf="title.touched && title.errors?.['required']">
                    Tittle is required.
                </span>
            </div>
            <div class="form-group">
                <label for="type">Type <span class="required">*</span></label>
                <select id="type" formControlName="type">
                    <option value="">Select Type</option>
                    <option *ngFor="let t of tagsData?.notificationTypes" [value]="t?.name">{{ t?.name }}</option>
                </select>
                <span class="text-danger" *ngIf="type.touched && type.errors?.['required']"> Type is required. </span>
            </div>
            <div class="form-group">
                <label for="audience">Target Audience <span class="required">*</span></label>
                <select id="audience" formControlName="audience" (change)="onModuleChange($event,'custom')">
                    <option value="">Select Target Audience</option>
                    <option *ngFor="let a of tagsData?.audienceTypes" [value]="a?.code">{{ a?.code }}</option>
                </select>
                <span class="text-danger"*ngIf="audience.touched && audience.errors?.['required']">
                    Target Audience is required.
                </span>
            </div>
            <div class="form-group">
                <label for="module">Redirect Module <span class="required">*</span></label>
                <select id="module" formControlName="module" (change)="onModuleChange($event,'playlist')">
                    <option value="">Select Redirect Module</option>
                    <option *ngFor="let m of filteredModules" [value]="m?.id">{{ m?.screenCode }}</option>
                </select>
                <span class="text-danger" *ngIf="module.touched && module.errors?.['required']">
                    Redirect Module is required.
                </span>
            </div>
            <div class="form-group" *ngIf="showPlayistDiv">
                <label for="module">Select Playlist<span class="required">*</span></label>
                <select id="module" formControlName="subModule">
                    <option value="" selected>Select Playlist</option>
                    <option *ngFor="let m of tagsData?.globlePlaylistName" [value]="m?.id">{{ m?.playlistName }}
                    </option>
                </select>
                <span class="text-danger" *ngIf="subModule.touched && subModule.errors?.['required']">
                    Playlist is required.
                </span>
            </div>
            <div class="form-group" *ngIf="showGenreDiv">
                <label for="module">Select Genre<span class="required">*</span></label>
                <select id="module" formControlName="subModule">
                    <option value="" selected>Select Genre</option>
                    <option *ngFor="let m of tagsData?.topGenreList" [value]="m?.id">{{ m?.name }}</option>
                </select>
                <span class="text-danger" *ngIf="subModule.touched && subModule.errors?.['required']">
                    Genre is required.
                </span>
            </div>
            <div class="upload-wrapper" *ngIf="showCustomUploadDiv">
                <div class="upload-header">Custom Upload</div>
                <div class="upload-box">
                    <input type="file" id="fileUpload" accept=".csv,.xlsx,.xls" (change)="onFileSelect($event)" hidden>
                    <label for="fileUpload" class="upload-btn">
                        📄 Upload CSV / Excel
                    </label>
                    <button type="button" class="upload-btn" (click)="downloadSampleExcel()"> ⬇️ Download Sample
                        File</button>
                </div>
                <span>{{ExcelFileName}}</span>
            </div>
            <div class="form-group full">
                <label for="message">Message <span class="required">*</span>
                    <span class="char-count">{{ message.value?.length || 0 }}/500</span>
                </label>
                <textarea id="message" formControlName="message"
                    placeholder="Enter your  Message..." (keypress)="wordLimitValidator($event,'message')" (paste)="handlePaste($event)" ></textarea>
                <span class="text-danger" *ngIf="message.touched && message.errors?.['required']">
                    Message is required.
                </span>
            </div>
        </div>
        <div class="media-section">
            <span class="media-label">Media (Optional)</span>
            <div *ngIf="imagePreviewUrl" class="image-preview-wrapper">
                <img [src]="imagePreviewUrl" alt="Media Preview" class="image-preview" />
                <button type="button" class="remove-img-btn" (click)="removeImage()">✕ Remove</button>
            </div>
            <div class="upload-box" *ngIf="!imagePreviewUrl" (click)="mediaInput.click()">
                <div class="upload-text">
                    {{ mediaFile ? mediaFile.name : 'Choose image' }}
                </div>
            </div>
            <input #mediaInput type="file" accept="image/*,video/*" style="display:none"
                (change)="onMediaChange($event)" />
        </div>
        <div class="delivery-card">
            <div class="delivery-header">Delivery Schedule</div>
            <div class="toggle-group" role="tablist">
                <button type="button" role="tab" class="toggle" [class.active]="activeTab === 'ONE_TIME'"
                    (click)="switchTab('ONE_TIME')">
                    One-Time
                </button>
                <button type="button" role="tab" class="toggle" [class.active]="activeTab === 'WEEKLY_RECURRING'"
                    (click)="switchTab('WEEKLY_RECURRING')">
                    Weekly Recurring
                </button>
            </div>
            <div *ngIf="activeTab === 'ONE_TIME'" class="tab-panel" role="tabpanel">
                <div class="schedule-grid">
                    <div>
                        <label class="field-label" for="oneTimeDate">Date <span class="required"> *</span></label>
                        <div class="input-wrap">
                            <input [min]="today"  id="oneTimeDate" type="date" formControlName="oneTimeDate" />
                        </div>
                        <span class="text-danger" *ngIf="oneTimeDate.touched && oneTimeDate.errors?.['required']">
                            Date is required.
                        </span>
                    </div>
                    <div>
                        <label class="field-label" for="oneTimeTime">Time</label>
                        <div class="input-wrap">
                            <input id="oneTimeTime" type="time" formControlName="oneTimeTime" />
                        </div>
                        <span class="text-danger" *ngIf="oneTimeTime.touched && oneTimeTime.errors?.['required']" >Time is required</span>
                    </div>
                </div>
                <div class="schedule-hint" [ngClass]="scheduleHint.type"> {{ scheduleHint.text }} </div>
            </div>
            <div *ngIf="activeTab === 'WEEKLY_RECURRING'" class="tab-panel" role="tabpanel">
                <label class="field-label">
                    Select Days <span class="required">*</span>
                </label>
                <div class="days-grid">
                    <button *ngFor="let day of allDays" type="button" class="day-btn"
                        [class.selected]="isDaySelected(day)" [class.error-day]="daysError && !isDaySelected(day)"
                        (click)="toggleDay(day)">
                        {{ day }}
                    </button>
                </div>
                <span class="text-danger" *ngIf="daysError">
                    Please select at least one day.
                </span>

                <label class="field-label" for="weeklyDate" style="margin-top: 14px;">
                    Send Date
                </label>
                <div class="input-wrap time-wrap">
                    <input id="weeklyDate" type="date" formControlName="weeklyDate" />
                </div>
                <span class="text-danger" *ngIf="weeklyDate.touched && weeklyDate.errors?.['required']" >Date is required</span>
                <label class="field-label" for="weeklyTime" style="margin-top: 14px;">
                    Send Time
                </label>
                <div class="input-wrap time-wrap">
                    <input id="weeklyTime" type="time" formControlName="weeklyTime" />
                </div>
                <span class="text-danger" *ngIf="weeklyTime.touched && weeklyTime.errors?.['required']" >Time is required</span>
                <div class="schedule-hint" [ngClass]="scheduleHint.type">
                    {{ scheduleHint.text }}
                </div>
            </div>
        </div>
        <button type="submit" class="schedule-btn">
            {{editMode ? 'Update Schedule Notification' : 'Schedule Notification'}}
        </button>
        <button type="button" class="cancel-btn" (click)="cancelForm()">
            Cancel
        </button>
    </form>
</div>

<div class="toast" [class.show]="toastVisible">{{ toastMessage }}</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>